// import ManHide from '@/Assets/Images/ManHide.png'
import DogQuestion from "@/Assets/Images/DogQuestion.png";
import BlowMind from "@/Assets/Images/BlowMind.png";
import BalancingAct from "@/Assets/Images/BalancingAct.png";
import ManHide from "@/Assets/Images/ManHide.png";
import Motivation from "@/Assets/Images/Motivation.png";
import ForestSun from "@/Assets/Images/ForestSun.png";
import Binoculars from "@/Assets/Images/Binoculars.png";

const blogData = [
  {
    title: "LA QUESTION QUI TUE....!",
    description:
      "Comment décrire vos points forts et vos points faibles? L'incontournable question dans un entretien d'embauche! Cette demande peut être embarrassante, surtout si vous n'avez pas bien réfléchi à la manière d'y répondre. Pourtant, il s'agit d'une question souvent posée en entrevue.",
    picture: DogQuestion,
    pictureAlt: "Chien regardant un point d'interrogation",
    PageLink: "/blog/La_Question_qui_Tue",
    categorie: ["recherche d'emploi"],
    width: 265,
    height: 220,
  },
  {
    title: "Souffrez vous de l'hyperchoix ?",
    description:
      "L'abondance de possibilités rend souvent les décisions plus difficiles.  Face à une multitude d'options, nous sommes parfois paralysés.",
    picture: BlowMind,
    pictureAlt: "à definir",
    PageLink: "/blog/Souffrez_vous_de_l'hyperchoix",
    categorie: ["évolution professionnelle"],
    width: 500,
    height: 400,
  },
  {
    title: "CELUI QUI A DU COURAGE A PEUR!",
    description:
      "Dans la quête du succès, la plupart des gens connaissent les étapes à suivre. Des milliers d'auteurs partagent leurs stratégies gagnantes . Pourtant, malgré cette abondance de connaissances, la clé de la réussite réside davantage dans le courage d'agir que dans la simple accumulation de savoirs ou de méthodes.",
    picture: BalancingAct,
    pictureAlt: "à definir",
    PageLink: "",
    categorie: ["évolution professionnelle"],
  },
  {
    title: "TROUVER SA VOIE : UNE APPROCHE CONSTRUCTIVISTE",
    description:
      "Découvrez comment adopter une approche constructiviste pour trouver votre voie professionnelle. Apprenez à travers la réflexion personnelle, l'exploration active, les rencontres, le développement continu, et l'évaluation régulière. Construisez une carrière épanouissante et alignée avec vos aspirations.",
    picture: Binoculars,
    pictureAlt: "femme regardant vers nous avec des jumelles",
    PageLink: "/blog/Trouver_sa_Voie",
    categorie: ["évolution professionnelle"],
    width: 1228,
    height: 755,
  },
  {
    title: "VISUALISER VOTRE CARRIÈRE IDÉALE POUR UNE RECONVERSION RÉUSSIE ",
    description:
      "Visualiser votre carrière idéale est fondamentale pour une reconversion réussie. Fixez un cap, renforcez votre motivation et élaborez une stratégie concrète pour atteindre vos objectifs",
    picture: ForestSun,
    pictureAlt: "Forêt avec un soleil au dessus",
    PageLink:
      "/blog/visualiser_votre_carriere_ideale_pour_une_reconversation_reussie",
    categorie: ["évolution professionnelle"],
    width: 2532,
    height: 1511,
  },
  {
    title: "Démotivation vs Amotivation ",
    description:
      "Découvrez les différences entre démotivation et amotivation. Apprenez à identifier les causes de chaque état et comment les surmonter pour raviver votre motivation.",
    picture: Motivation,
    pictureAlt: "femme avec sa main droite sur le front devant son ordinateur",
    PageLink: "/blog/Motivation_vs_amotivation",
    categorie: ["évolution professionnelle"],
    width: 325,
    height: 250,
  },
  {
    title: "A CHACUN SA QUESTION QUI TUE EN ENTRETIEN D’EMBAUCHE....!",
    description:
      "Ça y est, vous y êtes! Vous êtes confiant puisque vous maîtrisez le b-a-ba de la parfaite préparation à l’entretien. Rien ne pourrait venir troubler votre paisible ascension vers le succès… Rien jusqu’à l’arrivée de .......",
    picture: ManHide,
    pictureAlt: "à definir",
    PageLink: "/blog/A_chacun_sa_question_qui_tue_en_entretien_d_embauche",
    categorie: ["Conseils recherche d'emploi"],
    width: 389,
    height: 198,
  },
];

export default blogData;
